/* unplugin-vue-components disabled */import script from "./indexPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=ts"

import "./indexPage.vue?vue&type=style&index=0&id=7bb2b8c9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb2b8c9"]])

export default __exports__